module.exports = __webpack_public_path__ + "static/media/ic_video_on.0d62f927.svg";